// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2GbXC","label":"Category_label__3KsUZ","content":"Category_content__1pEZu","header":"Category_header__17QVa","location":"Category_location__LP67C"};